import React from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import AuthCard from "@/components/AuthCard";

const VisuallyHidden = ({ children }) => (
  <span className="absolute w-px h-px p-0 -m-px overflow-hidden whitespace-nowrap border-0">
    {children}
  </span>
);

const AuthModal = ({ open, onOpenChange }) => {
  // onOpenChange may be a no-arg close handler from AuthContext;
  // Radix passes (open: boolean) — wrap so both shapes work.
  const handleOpenChange = (next) => {
    if (typeof onOpenChange !== "function") return;
    if (onOpenChange.length === 0) {
      if (!next) onOpenChange();
    } else {
      onOpenChange(next);
    }
  };
  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent
        data-testid="auth-modal"
        className="p-0 border-0 bg-transparent shadow-none w-full max-w-md sm:max-w-md"
        aria-describedby="auth-modal-desc"
      >
        <VisuallyHidden>
          <DialogTitle>Sign in to CMH</DialogTitle>
          <DialogDescription id="auth-modal-desc">
            Authenticate with Google or request a magic link by email.
          </DialogDescription>
        </VisuallyHidden>
        <AuthCard variant="modal" />
      </DialogContent>
    </Dialog>
  );
};

export default AuthModal;
